export default __webpack_public_path__ + "static/media/arrow-gray-open-icon.d07ce54e.svg";